export var adaptNESWtoENSW = function adaptNESWtoENSW(_ref) {
  var _ref$ne = _ref.ne,
      north = _ref$ne.lat,
      east = _ref$ne.lng,
      _ref$sw = _ref.sw,
      south = _ref$sw.lat,
      west = _ref$sw.lng;
  return {
    east: east,
    north: north,
    south: south,
    west: west
  };
};